import React, { useState } from "react";
import { Input, Button } from "antd";
import { Col, Row, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import history from "../../../routes/history"
import "./EmpHeadShot.css";

const EmpHeadShot = () => {
  const location = useLocation();
  const [fileList, setfileList] = useState(location.state.fileList);

  return (
    <>
      <div>
        <Col xs={22} sm={22} md={12} lg={12} style={{ margin: "auto" }}>
          <Input
            className="empHeadShot-search"
            size="large"
            placeholder="Find candidates or skill listings"
            prefix={<SearchOutlined className="site-form-item-icon" />}
          />
          <ArrowLeftOutlined className="empHeadShot-back" />
          <div className="empHeadShot-heading">Tell Us More About Your Employee</div>
          <div className="empHeadShot-txt">
          Share more about your employee, the impact they’ve made, and their experience working at the company.
          </div>
          <ImgCrop className="upload" rotate>
            <Upload
              //   action={uploadImage}

              fileList={fileList}
            >
              <img src={location.state.ImageURL} />
            </Upload>
          </ImgCrop>
          <button
            className="empHeadShot-btn"
            onClick={() => history.push("/companyprofile/addemployee/empdetails")}
          >
            Next
          </button>
        </Col>
      </div>
    </>
  );
};

export default EmpHeadShot;
